import classnames from 'classnames';
import { ReactElement } from 'react';

type IconButtonProps = {
  icon: ReactElement;
  label: string;
  className?: string;
  size?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function IconButton(props: IconButtonProps) {
  const {
    icon,
    label,
    className: providedClassName,
    size: providedSize,
    ...rest
  } = props;
  const size = providedSize || 'md';
  const clazz = classnames(
    'tw-inline-flex tw-items-center tw-justify-center tw-border tw-border-gray-300 tw-bg-gray-100 hover:tw-bg-gray-200 tw-rounded-full',
    {
      'tw-p-2': size === 'md',
      'tw-p-1': size === 'sm',
    },
    providedClassName,
  );
  return (
    <button className={clazz} {...rest}>
      {icon}
      <span className='vh'>{label}</span>
    </button>
  );
}
